/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace component-selector component-class-suffix */
// noinspection CssUnknownTarget

import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit
}                                from '@angular/core';

import { Subscription          } from 'rxjs';

import { TaskProgressService   } from '@/services/task.progress.service';

import { Logger                } from '@/util/logger';
import { TaskUpdate            } from "@/models/task.update";

import * as $                   from 'jquery';


@Component({
  selector: '.task-progress',
  template: `

    <div id="taskprogressdropfill" style="height: 30px; overflow: hidden; margin-left: 4px;">
      <span (click)="toggle()" class="dropmenu-title" [innerHTML]="progressTitle"></span>
      <div (click)="toggle()" class="dropmenu-up-content" [class.closed]="!opened" [class.opened]="opened"
           style="padding: 0; width: 480px; height: 200px; cursor: default;">

        <div class="task-progress-panel-header">

          <div style="display: block; height: 16px;">
            <label style="display: block; float: left; height: 16px;">Tasks</label>
            <span (click)="clear()"
                  style="cursor: pointer; display: block; float: right; height: 16px; width: 16px; background-color: #AFB1B3; -webkit-mask-size: 16px 16px; -webkit-mask-image: url('/assets/images/trash-16.png'); mask-size: 16px 16px; mask-image: url('/assets/images/trash-16.png');"></span>
          </div>

          <div style="clear: both; height: 1px"></div>

        </div>

        <div class="task-progress-panel">
        </div>

      </div>
    </div>
  `
})

/**
 *
 * @class TaskProgressComponent
 *
 * @brief drop up menu (bottom margin) we can click for long-running task status
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      December 2021
 *
 */
export class TaskProgressComponent implements OnInit, OnDestroy, AfterViewInit {

  /** the observable for alerts we are interested in */
  private subscription:      Subscription;

  /** the pop-up window we put the tasks in */
  private panel: HTMLElement              = null;

  /** the current task (via their latest update */
  private tasks: Map<string, TaskUpdate>  = new Map<string, TaskUpdate>();

  /** hid/display the pup up */
  public opened: boolean                  = false;

  /** the menu bar label */
  public progressTitle: string            = 'No Tasks';

  constructor(
    private taskMonitor: TaskProgressService
  ) {

    Logger.debug('[TaskProgressComponent]', 'constructing...');

  }

  ngAfterViewInit(): void {

    Logger.debug('[TaskProgressComponent]', 'after view init...');

  }

  /** @brief set up the dockable views and view manager */
  ngOnInit(): void {

    let tpc = this;

    Logger.debug('[TaskProgressComponent]', 'on init...');

    /* establish where we dump tasks update sub-panels */

    this.panel = $(`.task-progress-panel`).get(0);

    /* subscribe to any and all tasks */

    tpc.subscription = tpc.taskMonitor.onAnyProgress().subscribe((update: TaskUpdate) => {

      Logger.debug('[TaskProgressComponent] update', update);

      /* is there an older update? */

      let previous: TaskUpdate = null;

      if (tpc.tasks.has(update.id)) {

        previous = tpc.tasks.get(update.id);

      } else {

        /* when we add new stuff, pop the panel to make the user notice */

        this.opened = true;
      }

      /* replace/set ... */

      this.tasks.set(update.id, update);

      let domId: string = `task-progress-${update.id}`;

      /* wait for the DOM to be ready, it has to be available whether creating or updating */

      if (!$(tpc.panel).find(`#${domId}`).is('div')) {

        /* add a sub-panel if we have to */

        $(tpc.panel).prepend(`<div id="${domId}" class="task-progress-sub-panel"></div>`);
      }

      /* wait for sub-panel to be available then render into it */

      Logger.debug(`[TaskProgressComponent] waiting for ${domId}...`);

      let waitForDom = () => {

        if ($(tpc.panel).find(`#${domId}`).is('div')) {

          /* panel is ready */

          Logger.debug(`[TaskProgressComponent] rendering ${domId}...`);

          let subPanel: HTMLElement = $(tpc.panel).find(`#${domId}`).get(0);

          $(subPanel).html(update.render());

          return ;
        }

        /* continue waiting ... */

        setTimeout( waitForDom, 50);
      };

      waitForDom();

      /* update the title */

      this.updateTitle();
    });
  }

  /** how many tasks? */
  total(): number {

    return this.tasks.size;
  }

  /** how many tasks are in progress? */
  inProgress(): number {

    return Array.from(this.tasks.values()).filter(x => !x.isComplete()).length;
  }

  /** how many tasks are completed? */
  completed(): number {

    return Array.from(this.tasks.values()).filter(x => x.isComplete()).length;
  }

  /** freshen the menu bar title */
  updateTitle() {

    this.progressTitle = "No Tasks";

    if (this.total() > 0) {

      this.progressTitle = `${this.completed()} of ${this.total()} Complete`;

    }

    /*
     * when any changes happen, check for tasks being complete...if nothing is outstanding,
     * close the panel.
     *
     */

    if (this.inProgress() == 0) {

      this.opened = false;
    }
  }

  /** force the panel open (or not) */
  toggle() {

    if (this.opened) {

      Logger.debug(`[TaskProgressComponent] toggling closed.`);

      this.opened = false;

    } else {

      Logger.debug(`[TaskProgressComponent] toggling open.`);

      this.opened = true;
    }
  }

  /** remove any tasks that are complete */
  clear() {

    Logger.debug(`[TaskProgressComponent] clearing...`);

    Array.from(this.tasks.keys()).forEach((key: string) => {

      let update: TaskUpdate = this.tasks.get(key);

      if (!update.isComplete()) {

        /* it's not done yet. */

        return ;
      }

      /* remove the task */

      this.tasks.delete(key);

      /* remove the DOM */

      let domId: string = `task-progress-${update.id}`;

      $(`#${domId}`).remove();

    });

    /* update the menu button */

    this.updateTitle();
  }

  ngOnDestroy() {

    this.subscription.unsubscribe();
  }


}
